import { render, staticRenderFns } from "./NavigationDrawerGroupTile.vue?vue&type=template&id=2b8e3ab9&"
import script from "./NavigationDrawerGroupTile.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerGroupTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports